// import { useEffect, useState } from 'react';
// import { useImageLoadQueue } from '@context/ImageLoadQueue';

// export default function ImageShow({
//   className,
//   style,
//   src,
//   altText,
//   onClick,
//   imageRef,
// }) {
//   const [visible, setVisible] = useState(false);
//   const { register, onImageLoaded } = useImageLoadQueue?.() || {};
//   const id = src;

//   useEffect(() => {
//     if (!src) return;

//     if (register && onImageLoaded) {
//       register(id, () => {
//         const img = new Image();
//         img.src = src;

//         img.onload = () => {
//           setVisible(true);
//           onImageLoaded(id);
//         };

//         img.onerror = () => {
//           console.error('❌ Failed:', src);
//         };
//       });
//     } else {
//       // No queue provider? Load immediately
//       const img = new Image();
//       img.src = src;

//       img.onload = () => setVisible(true);
//     }
//   }, [id]);

//   if (!visible) return null;

//   return (
//     <img
//       src={src}
//       className={className}
//       style={style}
//       alt={altText}
//       onClick={onClick}
//       ref={imageRef}
//       loading="lazy" // ✅ ช่วย browser delay load ถ้ายังไม่เข้า viewport
//     />
//   );
// }

import { useState, useEffect } from 'react';

export default function ImageShow({ className, style, typeUrl, src, altText, onClick }) {
  const [urlImage, setUrlImage] = useState("");

  useEffect(() => {
    setUrlImage(src);
  }, [typeUrl, src]);

  return urlImage && (
    <img
      className={className}
      style={style}
      src={urlImage}
      alt={altText}
      onClick={onClick}
      loading="lazy"
      decoding="async"
    />
  );
}